// import constants from '../../constants'
import defaultTheme from './defaultTheme';
export default {
  ...defaultTheme,
  emptyMessage: '#111939',
  emptyIcon: '#e6e3d4'
};
